import React from 'react';
import { CASE_STATUS_CREATED } from './CaseConstants';
import CaseList from './CaseList';
import { APP_TERMS } from '../../app-terms';

const BREAD_CRUMBS = [
  { label: 'Case', to: '/user/case/created' },
  { label: 'Pending', to: '/user/case/created' },
];
const CreatedCases = () => {
  return (
    <div>
      <div>
        <CaseList
          title={APP_TERMS.created_case_list_title}
          caseStatus={CASE_STATUS_CREATED}
          breadCrumbItems={BREAD_CRUMBS}
        />
      </div>
    </div>
  );
};

export default CreatedCases;
